import {
  Thead,
  Tr,
  Th,
  Box,
} from '@chakra-ui/react';
import { FaSortAmountDownAlt, FaSortAmountUpAlt } from 'react-icons/fa';

import { TableColumn, TableSortValue } from '../types';

export function TableColumns<I extends EntityBase = EntityBase>({ columns, sort, grouped, onSortChange }: { 
  columns: TableColumn<I>[]; 
  sort?: TableSortValue<I>;
  grouped?: boolean;
  onSortChange?(sort?: TableSortValue<I>): void;
}) {
  
  const onColumnClick = (column: TableColumn<I>) => () => {
    if (!column.options.sort) {return;}
    if (!onSortChange) {return;}
    if (sort?.name === column.name) {
      onSortChange({
        name: column.name,
        direction: sort.direction === 'asc' ? 'desc' : 'asc',
      });
      return;
    }

    onSortChange({
      name: column.name,
      direction: 'asc',
    });
  };

  return <Thead>
    <Tr>
      {grouped && <Th></Th>}
      {columns.map((column, index) => <Th 
        key={`${column.name.toString()}_${index}`}
        borderColor='gray.300'
        p={1}
      >
        <Box 
          display='flex'
          gap={1}
          alignItems='center'
          cursor={column.options?.sort ? 'pointer' : 'default'}
          borderRadius='md'
          height='100%'
          px={5} py={2}
          whiteSpace='normal' 
          userSelect='none'
          _hover={column.options?.sort ? {
            backgroundColor: 'gray.100',
            'svg': {
              opacity: 0.7
            }
          } : undefined}
          onClick={onColumnClick(column)}
        >
          {column.label}
          {column.options?.sort && <SortIcon 
            active={sort?.name === column.name}
            direction={sort?.direction || 'asc'}
          />}
        </Box>
      </Th>)}
    </Tr>
  </Thead>;
}

const SortIcon = ({ active, direction }: { active: boolean, direction: 'asc' | 'desc' }) => {
  if (direction === 'desc') {
    return <FaSortAmountUpAlt opacity={active ? 1 : 0}
      style={{ minWidth: 24 }}
    />;
  }

  return <FaSortAmountDownAlt opacity={active ? 1 : 0}
    style={{ minWidth: 24 }}
  />;
};
